module.exports = __webpack_public_path__ + "img/preview-8.7be29f8f.png";